import { EmailIcon } from '@/icons';
import { Button, CircularProgress } from '@mui/material';
import { PropsWithChildren } from 'react';

type LoginButtonProps = PropsWithChildren<{
  loading?: boolean;
}>;

export function LoginButton({ children, loading }: LoginButtonProps) {
  return (
    <Button
      startIcon={loading ? <CircularProgress size={20} /> : <EmailIcon />}
      disabled={loading}
      variant="contained"
      type="submit"
      disableElevation
    >
      {children}
    </Button>
  );
}
